import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { View, Text, Image, Pressable } from 'react-native';
import ImgIC from '../../../assets/images/ic_guarantee.png';
import ImgShop from '../../../assets/images/shop_icon.png';
import { Button } from '../../Button/rn';
import { useLocale } from '../../LocaleProvider/rn';
import { useComponentTracking } from '../../../hooks/rn/useTracking';
import { ITEMS_TEXT, ITEM_TEXT, ORDER_ID_TRANSIFY_KEY, TOTAL_PAYMENT_TEXT, SELECT_ORDER_TEXT } from '../../../utils/constants';
import * as RNStyle from '../../../styles/rn';
import { FONT_WEIGHT_MEDIUM } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export var ProductCard = function ProductCard(props) {
  var shopName = props.shopName,
    title = props.title,
    specification = props.specification,
    amount = props.amount,
    itemCount = props.itemCount,
    orderPrice = props.orderPrice,
    totalPrice = props.totalPrice,
    orderSn = props.orderSn,
    handleOrderDetailRedirect = props.handleOrderDetailRedirect,
    orderStatusText = props.orderStatusText,
    _props$shopImg = props.shopImg,
    shopImg = _props$shopImg === void 0 ? ImgShop : _props$shopImg,
    image = props.image,
    _props$showOrderId = props.showOrderId,
    showOrderId = _props$showOrderId === void 0 ? false : _props$showOrderId,
    orderIdText = props.orderIdText,
    onButtonClick = props.onButtonClick,
    selectOrderText = props.selectOrderText,
    action = props.action,
    totalPaymentText = props.totalPaymentText,
    itemText = props.itemText,
    itemsText = props.itemsText,
    componentTrackingData = props.componentTrackingData,
    watchFn = props.watchFn;
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var _useComponentTracking = useComponentTracking({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    panelOrderTracking = _useComponentTracking2.panelOrder,
    panelOrderButtonTracking = _useComponentTracking2.panelOrderButton;
  var onClick = function onClick() {
    // 点击埋点
    (panelOrderButtonTracking === null || panelOrderButtonTracking === void 0 ? void 0 : panelOrderButtonTracking.trackingClick) && tracker.click(panelOrderButtonTracking.trackingClick);
    onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick({
      data: props
    });
  };
  var onOrderClick = function onOrderClick() {
    watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect('[ProductCard] order click');
    (panelOrderTracking === null || panelOrderTracking === void 0 ? void 0 : panelOrderTracking.trackingClick) && tracker.click(panelOrderTracking.trackingClick);
    handleOrderDetailRedirect === null || handleOrderDetailRedirect === void 0 ? void 0 : handleOrderDetailRedirect();
  };
  return /*#__PURE__*/React.createElement(Pressable, _extends({
    style: styles.product__container,
    key: orderSn,
    onPress: onOrderClick
  }, panelOrderTracking === null || panelOrderTracking === void 0 ? void 0 : panelOrderTracking.trackingImpressionProps, {
    onLayout: function onLayout(e) {
      var _e$nativeEvent$layout = e.nativeEvent.layout,
        width = _e$nativeEvent$layout.width,
        height = _e$nativeEvent$layout.height;
      watchFn === null || watchFn === void 0 ? void 0 : watchFn.collect("[ProductCard] ProductCard render, width:".concat(width, " height:").concat(height));
    }
  }), /*#__PURE__*/React.createElement(View, {
    style: styles['product-shop']
  }, /*#__PURE__*/React.createElement(View, {
    style: styles['product-shop__name']
  }, /*#__PURE__*/React.createElement(Image, {
    style: styles['product-shop__name-img'],
    source: typeof shopImg === 'number' ? shopImg : {
      uri: shopImg
    },
    alt: "shop"
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles['product-shop__name-text'],
    numberOfLines: 1
  }, shopName)), /*#__PURE__*/React.createElement(Text, {
    style: styles['product-shop__type']
  }, orderStatusText)), /*#__PURE__*/React.createElement(View, {
    style: styles['product-item']
  }, /*#__PURE__*/React.createElement(Image, {
    style: styles['product-item-img'],
    source: {
      uri: image
    },
    alt: "item"
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles['product-item__title'],
    numberOfLines: 1
  }, title), /*#__PURE__*/React.createElement(View, {
    style: styles['product-item__spec']
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles['product-item__desc'],
    numberOfLines: 1
  }, specification), /*#__PURE__*/React.createElement(Text, {
    style: styles['product-item__amount']
  }, "x", amount)), /*#__PURE__*/React.createElement(Text, {
    style: styles['product-item__price']
  }, orderPrice)), /*#__PURE__*/React.createElement(View, {
    style: styles['product-amount']
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles['product-amount__count']
  }, itemCount, " ", itemCount > 1 ? itemsText || trans(ITEMS_TEXT) : itemText || trans(ITEM_TEXT)), /*#__PURE__*/React.createElement(View, {
    style: styles['product-amount__price']
  }, /*#__PURE__*/React.createElement(Image, {
    style: styles['product-amount__price-img'],
    source: ImgIC,
    alt: "money"
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles['product-amount-text']
  }, totalPaymentText || trans(TOTAL_PAYMENT_TEXT), ': ', /*#__PURE__*/React.createElement(Text, {
    style: styles['product-amount__price-text']
  }, totalPrice)))), showOrderId && /*#__PURE__*/React.createElement(View, {
    style: styles['product-order-sn']
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles['product-order-sn__title']
  }, orderIdText || trans(ORDER_ID_TRANSIFY_KEY)), /*#__PURE__*/React.createElement(Text, {
    style: styles['product-order-sn__content']
  }, orderSn)), /*#__PURE__*/React.createElement(Pressable, _extends({
    style: styles['product-buttons'],
    onPress: function onPress(element) {
      return element.stopPropagation();
    }
  }, panelOrderButtonTracking === null || panelOrderButtonTracking === void 0 ? void 0 : panelOrderButtonTracking.trackingImpressionProps), /*#__PURE__*/React.createElement(Button, {
    styles: {
      containerStyle: styles['product-button']
    },
    type: "primary",
    onClick: onClick,
    action: action,
    text: selectOrderText || trans(SELECT_ORDER_TEXT),
    trackingData: componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData.selectOrderButton,
    componentData: {
      content: selectOrderText || trans(SELECT_ORDER_TEXT)
    }
  })));
};
var styles = CustomStyleSheet({
  product__container: {
    paddingVertical: 0,
    paddingHorizontal: 12,
    backgroundColor: '#ffffff',
    marginTop: 8
  },
  'product-shop': {
    paddingVertical: 12,
    paddingHorizontal: 0,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderBottomColor: 'rgba(0, 0, 0, 0.06)',
    flexDirection: 'row'
  },
  'product-shop__name': {
    flexGrow: 1,
    marginRight: 12,
    flexDirection: 'row',
    alignItems: 'center'
  },
  'product-shop__name-img': {
    marginRight: 8,
    width: 17,
    height: 17
  },
  'product-shop__name-text': {
    fontSize: 14,
    lineHeight: 15,
    color: 'rgba(0, 0, 0, 0.87)',
    flex: 1
  },
  'product-shop__type': {
    fontSize: 14,
    lineHeight: 16,
    color: RNStyle.brand
  },
  'product-item': {
    paddingVertical: 10,
    paddingHorizontal: 0,
    paddingLeft: 84,
    position: 'relative',
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.06)'
  },
  'product-item-img': {
    position: 'absolute',
    left: 0,
    top: 12,
    width: 72,
    height: 72
  },
  'product-item__title': {
    fontSize: 14,
    lineHeight: 16,
    margin: 0,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'product-item__spec': {
    marginTop: 13,
    flexDirection: 'row'
  },
  'product-item__desc': {
    flexGrow: 1,
    flexShrink: 1,
    marginRight: 12,
    fontSize: 12,
    color: '#888888',
    lineHeight: 14
  },
  'product-item__amount': {
    fontSize: 12,
    color: '#888888',
    lineHeight: 14
  },
  'product-item__price': {
    margin: 0,
    marginTop: 13,
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    textAlign: 'right'
  },
  'product-amount': {
    paddingVertical: 14,
    paddingHorizontal: 0,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderBottomColor: 'rgba(0, 0, 0, 0.06)',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  'product-amount-text': {
    fontSize: 14,
    lineHeight: 18,
    color: '#333333'
  },
  'product-amount__count': {
    color: '#000000'
  },
  'product-amount__price': {
    flexDirection: 'row'
  },
  'product-amount__price-img': {
    width: 18,
    height: 18,
    marginRight: 6
  },
  'product-amount__price-text': _objectSpread({
    color: RNStyle.brand
  }, FONT_WEIGHT_MEDIUM),
  'product-order-sn': {
    paddingVertical: 12,
    paddingHorizontal: 0,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderBottomColor: 'rgba(0, 0, 0, 0.06)',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  'product-order-sn__title': {
    fontSize: 14,
    color: '#333333',
    lineHeight: 17
  },
  'product-order-sn__content': {
    fontSize: 14,
    color: '#333333',
    lineHeight: 16
  },
  'product-buttons': {
    paddingVertical: 12,
    paddingHorizontal: 0,
    alignItems: 'flex-end'
  },
  'product-button': {
    minWidth: 0,
    marginHorizontal: 0,
    marginVertical: 0,
    paddingVertical: 10,
    paddingHorizontal: 10
  }
});